import * as _ from 'lodash';

let initialState;

export const InitialStatePlugin = store => {
    initialState = copyInitialState(store);
};

function copyInitialState(store) {
    return _.cloneDeep(store.state);
}

export function getInitialState() {
    return _.cloneDeep(initialState);
}


// WEBPACK FOOTER //
// ./src/store/plugins/InitialStatePlugin.js